
export class EditPatPresc {
    
    mname: string;
    strength: string;
    intakefreq:string;
    sdate: string;
    edate: string;
    prid: number;
    
}
